
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiHeader as ObcPoiHeaderElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-header/poi-header.js';
 
 
 

 
 export const ObcPoiHeader = createComponent({
   react: React,
   tagName: 'obc-poi-header',
   elementClass: ObcPoiHeaderElement,
   events: {
     
   }
  });
 
 